import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { colTypesWidths } from '~/components/ui/tables/ag/columnTypes';
import { agTheme } from '~/components/ui/tables/ag/agTheme';
import { colDefsInvitesTable, Invite } from './colDefsInvitesTable';

export type InvitesTableProps = {
  loading: boolean;
  rowData: Invite[];
};

export const InvitesTable = ({ loading, rowData }: InvitesTableProps) => {
  const gridRef = useRef<AgGridReact<Invite>>(null);

  return (
    <div style={{ height: '100%' }}>
      <AgGridReact
        rowData={rowData}
        ref={gridRef}
        loading={loading}
        columnDefs={colDefsInvitesTable}
        columnTypes={colTypesWidths}
        tooltipShowDelay={0}
        theme={agTheme}
        suppressContextMenu
        colResizeDefault="shift"
        suppressCellFocus
        onColumnResized={(params) => {
          if (params.finished) params.api.sizeColumnsToFit();
        }}
        autoSizeStrategy={{
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        }}
      />
    </div>
  );
};
